import { Avatar } from "@tellescope/design-system";
import type { MultiSelectOption } from "@tellescope/ui";

interface CareTeamMemberOptionProps {
  option: MultiSelectOption;
  avatar?: string;
  initials: string;
}

export const CareTeamMemberOption = ({ option, avatar, initials }: CareTeamMemberOptionProps) => (
  <div className="flex items-center gap-2">
    <Avatar size="sm" src={avatar} id={option.value}>
      {initials}
    </Avatar>
    <span className="text-sm truncate">{option.label}</span>
  </div>
);
